import { z } from 'zod';

/**
 * Return value of SynthesisService.processSingleDocument.
 * Used by the processor to populate the Redis file record on success.
 */
export const ProcessSingleDocumentResultSchema = z.object({
  synthesisDocumentId: z.string(),
  synthesisFilename: z.string(),
  originalDocumentTitle: z.string().nullable(),
  originalDocumentDescription: z.string().nullable(),
  synthesisDocumentName: z.string(),
  vectorizationResult: z.unknown().nullable(),
  originalVectorizationResult: z.unknown().nullable(),
  titleDescriptionResults: z.object({
    success: z.boolean(),
    title: z.string().nullable(),
    description: z.string().nullable(),
  }),
  processingTime: z.number().int().nonnegative(),
  regionUsed: z.string(),
  modelUsed: z.string(),
  providerUsed: z.string(),
});
export type ProcessSingleDocumentResult = z.infer<typeof ProcessSingleDocumentResultSchema>;
